import { combineReducers } from 'redux';
import catalog from './catalog';
import categories from './categories';
import item from './item';
import profileCatalog from './profileCatalog';

const reducer = combineReducers({
  catalog, categories, item, profileCatalog,
});
export default reducer;